import React from 'react';
import c from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import TextRenderer from '../../../TextRenderer/TextRenderer';
import UserIdentitySecondary from '../../../User/IdentitySecondary/UserIdentitySecondary';
import s from './DetailsDumb.scss';
const USER_AVATAR_SIZE = 28;
const DetailsDumb = ({ className, title, withAuthorDetails = true, withOwnerDetails = false, author, owner, rightSlot, withDescriptionBlock, description })=>{
    const shop_card_no_gap = useFlag('shop_card_no_gap');
    if (!shop_card_no_gap && withOwnerDetails && owner) {
        withAuthorDetails = false;
    }
    return /*#__PURE__*/ React.createElement(Flex, {
        direction: "column",
        className: c(s['root'], owner && withOwnerDetails && !shop_card_no_gap && s['has-owner'], shop_card_no_gap && s['no-bottom-pad'], className)
    }, /*#__PURE__*/ React.createElement(Flex, {
        direction: "row",
        alignItems: "stretch"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-cell']
    }, withAuthorDetails && /*#__PURE__*/ React.createElement("div", {
        className: s['avatar']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        user: author,
        size: USER_AVATAR_SIZE
    }))), /*#__PURE__*/ React.createElement("div", {
        className: c(s['two-center-cells'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), owner && withOwnerDetails && !shop_card_no_gap && /*#__PURE__*/ React.createElement(UserIdentitySecondary, {
        size: "small",
        user: owner,
        className: s['owner-ident']
    }), author && (shop_card_no_gap || !withOwnerDetails) && /*#__PURE__*/ React.createElement("div", {
        className: s['username']
    }, withAuthorDetails && /*#__PURE__*/ React.createElement(UserLink, {
        user: author
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-cell']
    }, rightSlot)), withDescriptionBlock && /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, description && (typeof description === 'string' ? description : /*#__PURE__*/ React.createElement(TextRenderer, {
        className: s['description-text'],
        textContent: description
    }))));
};
DetailsDumb.displayName = 'DetailsDumb';
export default DetailsDumb;
